import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { GetBillTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import translate from "@insite/client-framework/Translate";
import { DataTableProps } from "@insite/mobius/DataTable";
import { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { sharedStyled } from "@store/Components/Customer/CommonStyle";
import CustomerSearchField from "@store/Components/Customer/CustomerSearchField";
import CustomerTable from "@store/Components/Customer/CustomerTable";
import PaginationCustomer from "@store/Components/Utils/PaginationCustomer";
import mapValues from "lodash/mapValues";
import React, { useState } from "react";

interface OwnProps {
    selectCustomerHandler: Function;
    currentBillTo: string;
    billTosDataView: any;
    setParameter: (parameter: GetBillTosApiParameter) => void;
    parameter: GetBillTosApiParameter;
}

export interface BillToSelectionStylesStyles {
    selectorDynamicDropdown?: InjectableCss;
    tableHead?: DataTableHeadProps;
    customerRow?: DataTableRowProps;
    selectionTitle?: TypographyProps;
    searchGridItem?: GridItemProps;
    customerTableColHeader?: DataTableHeaderProps;
    radioRowHeader?: DataTableHeaderProps;
    addressTableColHeader?: DataTableHeaderProps;
    idRowHeader?: DataTableHeaderProps;
    cityTableColheader?: DataTableHeaderProps;
    table?: DataTableProps;
    contentWrapper?: InjectableCss;
    tableWrapper?: InjectableCss;
    container?: GridContainerProps;
}

export const billToSelectionStyles: BillToSelectionStylesStyles = {
    ...sharedStyled,
};

const styles = billToSelectionStyles;

const BillToSelection = ({
    selectCustomerHandler,
    currentBillTo,
    billTosDataView,
    parameter,
    setParameter,
}: OwnProps) => {
    const { value } = billTosDataView;

    if (!value) {
        return null;
    }

    return (
        <StyledWrapper {...styles.contentWrapper}>
            <StyledWrapper {...styles.tableWrapper}>
                <CustomerTable
                    currentItems={value}
                    styles={styles}
                    currentShipTo={currentBillTo}
                    selectCustomerHandler={selectCustomerHandler}
                    isShipTo={false}
                />
            </StyledWrapper>
            <PaginationCustomer dataView={billTosDataView} setParameter={setParameter} parameter={parameter} />
        </StyledWrapper>
    );
};

export default BillToSelection;
